import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import {
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_S,
  DEFAULT_MARGIN_XS,
} from "@src/common/styles/const";
import { defaultLetterSpacing } from "@src/common/styles/mixins";
import { TestStatus } from "@src/modules/shared/types";

const getBgColor = (status: TestStatus, isActive?: boolean) => {
  switch (status) {
    case TestStatus.Ready:
      return isActive ? colors.testPassedActive : colors.testPassedDefault;
    case TestStatus.Notes:
      return colors.testPassedActive;
    case TestStatus.InProgress:
      return isActive
        ? colors.testInProgressActive
        : colors.testInProgressDefault;
    case TestStatus.ActionNeeded:
      return isActive
        ? colors.testActionNeededActive
        : colors.testActionNeededDefault;
    case TestStatus.Fail:
      return isActive ? colors.testFailedActive : colors.testFailedDefault;
  }
};

const getActiveBorderColor = (status: TestStatus) => {
  switch (status) {
    case TestStatus.Ready:
      return colors.green;
    case TestStatus.Notes:
      return colors.green;
    case TestStatus.InProgress:
      return colors.darkBlue;
    case TestStatus.ActionNeeded:
      return colors.yellow;
    case TestStatus.Fail:
      return colors.red;
  }
};

interface TestTileProps {
  status: TestStatus;
  isActive?: boolean;
  isBenchmark?: boolean;
}

export const TileWrapper = styled.div<TestTileProps>`
  position: relative;
  padding: ${DEFAULT_MARGIN_S}px ${DEFAULT_MARGIN_M}px;
  border: 1px solid
    ${(p) => (p.isActive ? getActiveBorderColor(p.status) : colors.white)};
  border-radius: 6px;
  cursor: pointer;
  margin: ${DEFAULT_MARGIN_S}px 0;
  overflow: hidden;
  background-color: ${(p) => getBgColor(p.status, p.isActive)};

  &:hover {
    background-color: ${(p) => getBgColor(p.status, true)};
  }

  ${(p) =>
    p.isActive &&
    css`
      &::before {
        content: "";
        width: 4px;
        height: 100%;
        position: absolute;
        left: -1px;
        top: 0;

        background-color: ${getActiveBorderColor(p.status)};
      }
    `}
`;

export const TestName = styled.div`
  ${defaultLetterSpacing};
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: ${colors.almostBlack};
`;

export const IntervalText = styled.div`
  ${defaultLetterSpacing};
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  color: ${colors.gray3};
`;

export const BenchmarkTag = styled.div`
  position: absolute;
  top: ${DEFAULT_MARGIN_S}px;
  right: ${DEFAULT_MARGIN_M}px;
  padding: ${DEFAULT_MARGIN_XS}px;
  border-radius: 6px;
  background-color: ${colors.background};
  color: ${colors.darkBlue};
  font-size: 10px;
  line-height: 14px;
`;
